import React from 'react';
import ReactDom from 'react-dom/client';
import AdminApp from './components/AdminApp';

// The document-wide vocabulary: the bundled mono face and the --wf-* design
// tokens. Loaded here so no screen can be the one that goes without them.
import './styles/app.scss';

ReactDom.createRoot(document.getElementById('root')!).render(
    // <React.StrictMode>
    // removed to stop double function calls
    // </React.StrictMode>
    <AdminApp />
);